var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'ico', 'bmp', 'avif'];
export const VIDEO_EXTENSIONS = ['mp4', 'webm', 'ogv', 'mov', 'avi', 'mkv', 'm4v'];
export const AUDIO_EXTENSIONS = ['mp3', 'wav', 'ogg', 'oga', 'm4a', 'aac', 'flac'];
/**
 * Extension of a URL or file name — lowercased, without the query string or
 * hash, and read from the last path segment only. Reading the whole path would
 * find the dot in the host instead ('images.unsplash.com/photo-123').
 */
export function getUrlExtension(value) {
    const path = (value || '').split('?')[0].split('#')[0];
    const file = path.substring(path.lastIndexOf('/') + 1);
    const dot = file.lastIndexOf('.');
    return dot < 0 ? '' : file.slice(dot + 1).toLowerCase();
}
/** Last path segment of a URL, percent-decoded — i.e. the file name. */
export function getFileNameFromUrl(value) {
    if (!value)
        return '';
    const path = value.split('?')[0].split('#')[0];
    const name = path.substring(path.lastIndexOf('/') + 1);
    if (!name)
        return value;
    try {
        return decodeURIComponent(name);
    }
    catch (e) {
        return name;
    }
}
/**
 * Normalise a user-typed URL so it always resolves absolutely. A protocol-less
 * value (e.g. `static.iviva.com/x.png`) would otherwise resolve relative to the
 * current page and silently fail to load.
 *  - `//host/path`      → `https://host/path`  (protocol-relative)
 *  - already has scheme → returned untouched   (http:, https:, data:, blob:, …)
 *  - anything else      → `https://` prepended
 */
export function normalizeUrl(raw) {
    const v = (raw || '').trim();
    if (!v)
        return v;
    if (v.startsWith('//'))
        return `https:${v}`;
    if (/^[a-z][a-z0-9+.-]*:/i.test(v))
        return v;
    return `https://${v}`;
}
/** Media kind of a URL or file name, from its extension. */
export function inferMediaKind(value) {
    const ext = getUrlExtension(value);
    if (IMAGE_EXTENSIONS.indexOf(ext) >= 0)
        return 'image';
    if (VIDEO_EXTENSIONS.indexOf(ext) >= 0)
        return 'video';
    if (AUDIO_EXTENSIONS.indexOf(ext) >= 0)
        return 'audio';
    return 'other';
}
export function validateAllowedFileType(fileType, allowedTypes, fileName) {
    // if types are not specified - assume all are allowed
    if (allowedTypes.length == 0)
        return true;
    // extension entries ('.rpt', '.csv') match against the file name — needed for
    // formats that have no standard MIME type (browsers report '' for them)
    const extensions = allowedTypes.filter(t => t.startsWith('.'));
    if (fileName && extensions.some(ext => fileName.toLowerCase().endsWith(ext.toLowerCase()))) {
        return true;
    }
    const mimeTypes = allowedTypes.filter(t => !t.startsWith('.'));
    if (mimeTypes.length == 0)
        return false;
    // check if file type is allowed
    let isAllowed = mimeTypes.find(t => t == fileType);
    if (isAllowed)
        return true;
    // get base type
    let [base, type] = fileType.split("/");
    // find in allowed types based on base type
    let allowed = mimeTypes.filter(t => t.startsWith(base));
    if (allowed.length == 0)
        return false;
    // check if all subtypes are allowed
    let allowedAll = allowed.find(t => t == [base, "*"].join("/"));
    return allowedAll != undefined;
}
export function blobToDataUrl(blob) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((done, nope) => {
            let fileReader = new FileReader();
            fileReader.onload = done;
            fileReader.readAsDataURL(blob);
        })
            .then((e) => e.target.result);
    });
}
/**
 * @export
 * A file size for people: bytes, KB or MB.
 */
export function formatFileSize(bytes) {
    const n = Number(bytes);
    if (!isFinite(n) || n < 0)
        return '';
    if (n < 1024)
        return `${n} B`;
    if (n < 1024 * 1024)
        return `${(n / 1024).toFixed(n < 10 * 1024 ? 1 : 0)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
